import NewTabs from '@editor/components/NewTabs/NewTabs';
import { PricingIntervals } from '@editor/types/Pricing';

/**
 * Props for the PlanIntervalTabs component
 * @interface Props
 * @property {PricingIntervals} activeTab - Currently selected pricing interval (Monthly/Yearly)
 * @property {(tab: string) => void} onTabClick - Callback function triggered when a tab is clicked
 */
type Props = {
  activeTab: PricingIntervals;
  onTabClick: (tab: string) => void;
};

/**
 * PlanIntervalTabs component displays a tabbed interface for selecting between monthly and yearly billing intervals.
 * It shows pricing interval options with a special label for yearly plans highlighting the discount.
 *
 * @component
 * @example
 * ```tsx
 * <PlanIntervalTabs
 *   activeTab={PricingIntervals.Monthly}
 *   onTabClick={(tab) => handleIntervalChange(tab)}
 * />
 * ```
 */
const PlanIntervalTabs: React.FC<Props> = ({ activeTab, onTabClick }) => {
  const planIntervalConfig = [
    {
      id: PricingIntervals.Monthly,
      label: 'Monthly',
    },
    {
      id: PricingIntervals.Yearly,
      label: 'Yearly',
      labelDescription: 'Up to 33% off',
    },
  ];

  return (
    <NewTabs
      tabsInfo={planIntervalConfig.map((tab) => {
        return {
          ...tab,
          isActive: tab.id === activeTab,
          isPlanIntervalTab: true,
        };
      })}
      onTabClick={onTabClick}
    />
  );
};

export default PlanIntervalTabs;
